// extracted by mini-css-extract-plugin
module.exports = {"businessNumber":"_1H-1ZHw2","address":"_2bU2lp3S","organisation":"_3TYYbsCG"};